/* eslint-disable react-hooks/exhaustive-deps */
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as wjCore from "@grapecity/wijmo";
import * as wjcGrid from "@grapecity/wijmo.grid";
import * as wjcInput from "@grapecity/wijmo.input";
import * as wjrGrid from "@grapecity/wijmo.react.grid";
import dayjs from "dayjs";
import _ from "lodash";
import queryString from "query-string";
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { AppDispatch } from "../../..";
import AlertComponent from "../../../components/AlertComponent";
import { showInfoToast } from "../../../components/CustomToast";
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel";
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter";
import YearInput from "../../../components/InputWrapper/YearInput";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import Spinner from "../../../components/Spinner";
import CONST from "../../../constant";
import { clearAlert, setAlerts } from "../../../globalStore/alertStore";
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore";
import { RootState } from "../../../globalStore/rootreducer";
import { TApiResponse } from "../../../service/TApiResponse";
import NenryoTankaService from "../../../service/truckcontrol/nenryotanka/nenryoTankaService";
import {
  TNenryoTankaGetListReq,
  TNenryoTankaGetListRes,
  TNenryoTankaPutListReq,
} from "../../../service/truckcontrol/nenryotanka/TNenryoTanka";
import pageHelper from "../../../ts/helpers/pageHelper";
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents";

/**
 * 燃料単価登録
 * @returns
 */
const NenryoTankaRegister = () => {
  const history = useHistory();
  const location = useLocation();
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr);

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  let gridId = "NenryoTankaRegister_GridId";

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TNenryoTankaGetListRes>) => {
    return new wjCore.CollectionView(data, {});
  };

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TNenryoTankaGetListReq) => {
    setIsSearching(true); // 検索中状態に遷移
    dispatch(clearAlert()); // アラートを非表示に
    setIsSubmitButton(false);
    // 削除用リストを初期化
    let clearList: TNenryoTankaGetListRes[] = [];
    setGridDataDeleteList(clearList);

    let currentSearchCondition: TNenryoTankaGetListReq;
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition;
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition();
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition);

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition),
    );

    try {
      const res = await new NenryoTankaService().getList(
        currentSearchCondition,
      );

      // 検索結果をstateにセット
      if (res.data.length < 1) {
        // DBのデータがなかったら新規の年度データを作成してSetする
        const 月数 = 12;
        const baseItemList: TNenryoTankaGetListRes[] = [];

        for (let i = 0; i < 月数; i++) {
          // 指定年/01/01 ~ /12/01
          const i年月 = dayjs()
            .year(currentSearchCondition.年!)
            .startOf("year")
            .add(i, "M")
            .format("YYYY/MM/DD");

          const items: TNenryoTankaGetListRes = {
            燃料単価ID: undefined,
            年月: i年月,
            燃料単価: 0,
            更新日時: "",
            削除フラグ: 0,
          };
          baseItemList.push(items);

          // ベースデータとして、検索年の１年分のダミーデータをセットする。
          setGridData({ data: createCollectionView(baseItemList) });
        }
      } else {
        // 検索結果が存在する場合の処理

        // 削除用リストを作成する
        let copyListNenryoTanka: TNenryoTankaGetListRes[] = [];
        res.data.forEach((d) => {
          // DeepCopy
          copyListNenryoTanka.push(_.cloneDeep(d));
        });
        setGridDataDeleteList(copyListNenryoTanka);

        // GridItem
        let gridItem: TNenryoTankaGetListRes[] = [];

        res.data.forEach((d) => {
          // DeepCopy
          gridItem.push(_.cloneDeep(d));
        });
        setGridData({ data: createCollectionView(gridItem) });
      }

      // MEMO:アコーディオン開閉は一旦なし
      // setAccordionController(false)
    } catch (error) {
      dispatch(setAlerts(error));
    } finally {
      setIsSearching(false); // 検索中状態に遷移
      setIsSubmitButton(true);
      flexGrid?.refresh();
    }
  };

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TNenryoTankaGetListReq = queryString.parse(location.search);
    set年(Number(query.年!));
    return query;
  };

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TNenryoTankaGetListReq => {
    return {
      検索年: dayjs().year(年!).startOf("year").format("YYYY/MM/DD"),
      年: 年,
    };
  };

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TNenryoTankaGetListReq,
  ) => {
    return {
      年: searchCondition.年,
    };
  };

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem);

    // タブ移動: 次の行へ折り返し、最終行で抜ける（月列はselectionChangingでスキップ）
    grid.keyActionTab = wjcGrid.KeyAction.CycleOut;

    // 月列（col=0）の選択を燃料単価列（col=1）へリダイレクト
    grid.selectionChanging.addHandler(
      (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
        if (e.col === 0) {
          e.cancel = true;
          setTimeout(() => s.select(e.row, 1));
        }
      },
    );

    // 選択行の非アクティブセルから選択ハイライトを除去
    grid.updatedView.addHandler((s: wjcGrid.FlexGrid) => {
      const sel = s.selection;
      if (sel.row < 0) return;
      for (let col = 0; col < s.columns.length; col++) {
        if (col === sel.col) continue;
        const cell = s.cells.getCellElement(sel.row, col);
        if (cell) {
          cell.classList.remove("wj-state-selected", "wj-state-multi-selected");
        }
      }
    });

    grid.refresh();
  };

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      // const cellBinding = e.getColumn().binding
      // const rowData: TNenryoTankaGetListRes = e.getRow().dataItem
      // let isExistData = true
      // if (!rowData) return
      //TODO: 当面チェック不要　（システム日の月より-2か月以前は入力不可）
      // システム日より古い場合にセルへ編集制御をかける
      // if (cellBinding?.includes("燃料単価")) {
      //   if (
      //     dayjs(rowData.年月).isBefore(dayjs(eigyobi).startOf("month").format())
      //   ) {
      //     f.rows[e.getRow().index].isReadOnly = true
      //     isExistData = false
      //   }
      //   wjCore.toggleClass(e.cell, "read-only-cell", !isExistData)
      // }
    }
  };

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true);
  };

  const submit = async () => {
    try {
      // DB更新用リスト
      let dataList: Array<TNenryoTankaPutListReq> = [];

      // 入力Gridを全て新規データとしてセットする
      gridData.data.items.forEach((d: TNenryoTankaGetListRes) => {
        // 新規データとするため、IDと更新一時は入れない
        let data: TNenryoTankaPutListReq = {
          燃料単価ID: undefined,
          年月: d.年月,
          燃料単価: d.燃料単価,
          更新日時: undefined,
          削除フラグ: 0,
        };
        dataList.push(data);
      });

      // 既存データを削除リストとしてセット
      gridDataDeleteList?.forEach((d: TNenryoTankaGetListRes) => {
        // 削除フラグを1にして追加
        let data: TNenryoTankaPutListReq = {
          燃料単価ID: d.燃料単価ID,
          年月: d.年月,
          燃料単価: d.燃料単価,
          更新日時: d.更新日時,
          削除フラグ: 1,
        };
        dataList.push(data);
      });

      const service = new NenryoTankaService();

      let res: TApiResponse<boolean>;

      // 更新対象のリストをserviceに渡す。
      res = await service.put(dataList);

      dispatch(setAlerts(res));
      if (res) {
        showInfoToast(`所定時間マスタの更新が完了しました。`);
      }

      // 遷移してきた際のクエリパラメータで検索条件を生成
      const querySearchCondition = queryParse();

      // リストア中フラグON
      setIsRestoreSearching(true);

      // 再検索
      // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
      search(querySearchCondition).finally(() => {
        dispatch(画面ロック解除());
      });
    } catch (error) {
      dispatch(setAlerts(error));
    } finally {
      setIsConfirmModalShow(false);
    }
  };

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false);

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>();
  const [pageSize, setPageSize] = useState<number>(10);
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  });
  // 削除リスト
  const [gridDataDeleteList, setGridDataDeleteList] =
    useState<TNenryoTankaGetListRes[]>();

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false);

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false); // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false); // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any;
  }>();

  //アラート制御
  const dispatch: AppDispatch = useDispatch();

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true);

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false);

  //#endregion

  //#region [state]
  // state
  const [年, set年] = useState<number>(parseInt(dayjs(eigyobi).format("YYYY")));

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `燃料単価登録`;
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始());
  }, []);

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse();

        // リストア中フラグON
        setIsRestoreSearching(true);

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除());
        });
      } else {
        // 初期表示: 今年のデータで自動検索
        search().finally(() => {
          dispatch(画面ロック解除());
        });
      }
    }
  }, [gridInitialized]);

  // 年変更時に自動検索
  useEffect(() => {
    if (!gridInitialized) return;
    if (年 == null || isNaN(年) || 年 < 1900 || 年 > 9999) return;
    search();
  }, [年]);

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">燃料単価登録</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-30rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}
            >
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="w-10rem">
                          <YearInput
                            id="年"
                            isRequired
                            value={年}
                            setValue={(v) => {
                              set年(v as number);
                            }}
                            placeholder="年"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card className="w-30rem h-100">
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>

              <FlexGridOuter
                hasFilter={false}
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={0}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                isShowGridHeader={false}
                isShowGridFooter={false}
                gridProperties={{
                  allowAddNew: false,
                  allowDelete: false,
                  allowSorting: wjcGrid.AllowSorting.None,
                  selectionMode: wjcGrid.SelectionMode.Cell,
                  showMarquee: false,
                }}
              >
                <wjrGrid.FlexGridColumn
                  binding="年月"
                  width={60}
                  format="d"
                  isRequired
                  isReadOnly
                  cssClass="read-only-cell"
                  header="月"
                >
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TNenryoTankaGetListRes>,
                    ) => {
                      return (
                        <>
                          <span>
                            {dayjs(context.item.年月).format("M") + "月"}
                          </span>
                        </>
                      );
                    }}
                  ></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="燃料単価"
                  width={160}
                  dataType={wjCore.DataType.Number}
                  format={"N0"}
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="燃料単価"
                ></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
              {/* フッター登録ボタン（グリッド下部） */}
              <div className="mt-2">
                <Button
                  type="button"
                  variant={isSubmitButton ? "primary" : "secondary"}
                  disabled={!isSubmitButton}
                  onClick={() => {
                    beforeSubmit();
                  }}
                >
                  登録
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}
      >
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  );
};

export default NenryoTankaRegister;
